import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { signInAnonymously } from "firebase/auth";
import { auth, database } from "../../firebase";
import { ENROLLMENT_YEAR } from "./documentConfig";

const COLLECTION_NAME = "formulariosInscripcion";
let enrollmentAuthPromise;

const ensureEnrollmentWriteAccess = async () => {
  if (auth.currentUser) return auth.currentUser;

  if (!enrollmentAuthPromise) {
    enrollmentAuthPromise = signInAnonymously(auth)
      .then(({ user }) => user)
      .catch((error) => {
        enrollmentAuthPromise = undefined;
        throw error;
      });
  }

  return enrollmentAuthPromise;
};

const getDocumentReference = (dni, documentType) =>
  doc(database, COLLECTION_NAME, dni, "documentos", documentType);

export async function loadEnrollmentDocument(dni, documentType) {
  const snapshot = await getDoc(getDocumentReference(dni, documentType));

  if (!snapshot.exists()) return {};

  const { values } = snapshot.data();
  return values && typeof values === "object" ? values : {};
}

export async function saveEnrollmentDocument(dni, documentType, values) {
  await ensureEnrollmentWriteAccess();
  const reference = getDocumentReference(dni, documentType);
  const existingDocument = await getDoc(reference);
  await setDoc(
    reference,
    {
      dni,
      documentType,
      values,
      lastSavedEnrollmentYear: ENROLLMENT_YEAR,
      ...(!existingDocument.exists() ? { createdAt: serverTimestamp() } : {}),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}
